import { Box, Card, CardContent, styled, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Column } from 'further-ui/components/Layout';
import React from 'react';

const BlueBar = styled(Box)(() => ({
  width: '100%',
  height: '8px',
  backgroundColor: blue[500],
}));

type Props = {
  label: string;
  value: string | React.ReactNode;
  subValue?: string | React.ReactNode;
  className?: string;
};

const PerformanceCard: React.FC<Props> = ({
  label,
  value,
  subValue,
  className,
}) => {
  return (
    <Card variant="outlined" key={label} className={className}>
      <CardContent>
        <Column centered spacing="xxs">
          <Typography variant="h6" color="grey.600">
            {label}
          </Typography>
          <Typography variant="h3">{value}</Typography>
          <Typography variant="body2" color="grey.900">
            {subValue}
          </Typography>
        </Column>
      </CardContent>
      <BlueBar />
    </Card>
  );
};

export default PerformanceCard;
